var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUaeFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 600,
    viewBox: "0 0 12 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 6,
    fill: "#00843d",
    id: "green"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 4,
    y: 2,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 2,
    y: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 6,
    fill: "#c8102e",
    id: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaeFlag);
export default __webpack_public_path__ + "static/media/uae_flag.9e042d6bf123efa5d5e31d5588f7f555.svg";
export { ForwardRef as ReactComponent };